export default __webpack_public_path__ + "static/zach-bitmoji-69c5bc9548bac5cfb11cff2aab6db0c3.png";